import React from 'react';
import {
  DataResult,
  toDataSourceRequestString
} from '@progress/kendo-data-query';
import { useToggle } from 'usehooks-ts';
import {
  ExcelExport,
  ExcelExportColumn
} from '@progress/kendo-react-excel-export';
import { useParams } from 'react-router-dom';

import { Downloadble } from '../../downloadable';
import { GetEventReportTaskAsync } from '../../../../services/event-reports';

export const DownloadableTask: React.FC<{
  amount: number;
  fileName: string;
}> = ({ amount, fileName }) => {
  const { eventId, detailId } = useParams();

  const [isLoading, toggleIsLoading] = useToggle(false);
  const gridExportRef = React.useRef<ExcelExport | null>(null);
  const shouldExportRef = React.useRef(false);

  const [dataGrid, setDataGrid] = React.useState<DataResult>(() => ({
    data: [],
    total: 0
  }));

  const onClick = async () => {
    toggleIsLoading();
    try {
      const response = await GetEventReportTaskAsync(
        eventId ?? '',
        detailId ?? '',
        `${toDataSourceRequestString({
          sort: [{ field: 'name', dir: 'asc' }],
          take: 0,
          skip: 0
        })}`
      );

      shouldExportRef.current = true;
      setDataGrid({
        data: response.data,
        total: response.total
      });
    } catch (err) {
      console.error(err);
    } finally {
      toggleIsLoading();
    }
  };

  React.useEffect(() => {
    if (shouldExportRef.current) {
      shouldExportRef.current = false;
      gridExportRef.current?.save();
    }
  }, [dataGrid]);

  return (
    <>
      <Downloadble
        text={'Tasks'}
        amount={amount}
        icon={'checklist'}
        bgColor={'#4698CB'}
        disabled={isLoading}
        downloadText={isLoading ? 'Downloading' : 'Download'}
        onClick={onClick}
      />

      <ExcelExport
        data={dataGrid.data}
        ref={gridExportRef}
        fileName={`${fileName}-tasks.xlsx`}>
        <ExcelExportColumn field={'name'} title={'Name'} />
        <ExcelExportColumn field={'percentage'} title={'Percentage'} />
        <ExcelExportColumn field={'activity'} title={'Game'} />
      </ExcelExport>
    </>
  );
};
